import React from 'react';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';

const DocumentDescription = ({ heading, text, link }) => {
  const needHeading = !!heading?.value;
  const needText = !!text?.value;
  const needLink = !!link?.value?.href;

  if (!needHeading && !needText && !needLink) return null;

  return (
    <div className="document-component-description">
      {needHeading && (
        <div className="dc-desc-title">
          <Text field={heading} />
        </div>
      )}
      {needText && <RichText className="dc-desc-text" field={text} />}
      {needLink && <Button link={link} variant="text" arrow="left" />}
    </div>
  );
};

export default DocumentDescription;
